module.exports = __webpack_public_path__ + "static/img/lunbo.462bf18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_0/lunbo.jpg
// module id = n85H
// module chunks = 0